import * as React from 'react';
import { List } from '../List/List';
import { Picture } from '~/Partials/Picture/Picture';
import { PicturePlaceholder } from '~/Partials/Picture/Placeholder/PicturePlaceholder';
import styles from './PersonInfo.module.css';
import type { PersonInfoViewModel } from './PersonInfoViewModel.csharp';

export const PersonInfo: React.FC<React.PropsWithChildren<PersonInfoViewModel>> = props => {
    const { name, picture, jobTitles, department, organization, link } = props;

    return (
        <div className={styles.PersonInfo}>
            {picture ? (
                <Picture {...picture} className={styles.Image} />
            ) : (
                <PicturePlaceholder className={styles.Image} />
            )}
            <div className={styles.MainInfo}>
                <h3 className={styles.Name}>{name}</h3>
                {jobTitles && (
                    <List
                        className={styles.JobTitles}
                        items={jobTitles}
                        renderItem={jobTitle => (
                            <li key={jobTitle}>
                                <strong className={styles.JobTitle}>{jobTitle}</strong>
                            </li>
                        )}
                    />
                )}
            </div>
            {organization && <p className={styles.Organization}>{organization}</p>}
            {department && <p className={styles.Department}>{department}</p>}
            {link && (
                <a href={link?.href} className="PersonInfo__linkOverlay">
                    <span className="visuallyHidden">{link?.label}</span>
                </a>
            )}
        </div>
    );
};
